import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as profileActions from '../SignInPage/actions'
import * as api from './api'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'
import history from '../../utils/history'

function* fetchCoursePage(payload: { id: string }): SagaIterator {
  try {
    const courses = yield effects.call(api.fetchCoursePage, payload.id)
    yield effects.put(actions.fetchCoursePageSuccess(courses.data))
    yield effects.put(profileActions.setCurrentCourseTitle(courses.data.title))
  } catch (error) {
    console.warn('Cannot fetch course page', error)
    yield effects.put(actions.fetchCoursePageFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* fetchCourseUserState(payload: { id: string }): SagaIterator {
  try {
    const courses = yield effects.call(api.fetchCourseUserState, payload.id)
    yield effects.put(actions.fetchCourseUserStateSuccess(courses.data))
  } catch (error) {
    console.warn('Cannot fetch course user state', error)
    yield effects.put(
      actions.fetchCourseUserStateFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* joinCourse(payload: { id: string }): SagaIterator {
  try {
    yield effects.call(api.joinCourse, payload.id)
    yield effects.put(actions.joinCourseSuccess())
  } catch (error) {
    console.warn('Cannot join course', error)
    yield effects.put(actions.joinCourseFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* joinModule(payload: {
  id: string
  mid: string
  sid: string
}): SagaIterator {
  try {
    const { id, mid, sid } = payload
    yield effects.call(api.joinModule, id, mid)
    yield effects.put(actions.joinModuleSuccess())
    if (sid) {
      yield effects.call(
        [history, history.push],
        `/courses/${id}/modules/${mid}/screens/${sid}`
      )
    } else {
      yield effects.call(
        [history, history.push],
        `/courses/${id}/modules/${mid}`
      )
    }
  } catch (error) {
    console.warn('Cannot join module', error)
    yield effects.put(actions.joinModuleFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* repayCourse(payload: { id: string }): SagaIterator {
  try {
    yield effects.call(api.repayCourse, payload.id)
    yield effects.put(actions.repayCourseSuccess())
    yield effects.put(actions.fetchCoursePage(payload.id))
  } catch (error) {
    console.warn('Cannot repay course', error)
    yield effects.put(actions.repayCourseFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchCoursePage(): SagaIterator {
  yield effects.takeEvery(actions.fetchCoursePage.toString(), fetchCoursePage)
}

function* watchFetchCourseUserState(): SagaIterator {
  yield effects.takeEvery(
    actions.fetchCourseUserState.toString(),
    fetchCourseUserState
  )
}

function* watchJoinCourse(): SagaIterator {
  yield effects.takeEvery(actions.joinCourse.toString(), joinCourse)
}

function* watchJoinModule(): SagaIterator {
  yield effects.takeEvery(actions.joinModule.toString(), joinModule)
}

function* watchRepayCourse(): SagaIterator {
  yield effects.takeEvery(actions.repayCourse.toString(), repayCourse)
}

export default function* watchCoursePage(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchCoursePage),
    effects.fork(watchFetchCourseUserState),
    effects.fork(watchJoinCourse),
    effects.fork(watchJoinModule),
    effects.fork(watchRepayCourse),
  ])
}
